import { useRequest, useTableInput } from '@stores';

import { RequestType } from '@utils/enums';
import { getAppStore } from '@utils/store-reference';

import { RequestType as RequestTypeType } from '@api/services/request/types';
import { FetchNprParams } from '@api/services/npr/hooks/useNprRequestHandler';
import { FetchNonPcnParams } from '@api/services/non-pcn/hooks/useNonPcnRequestHandler';
import { prefetchCreditUnitsByDistrict, prefetchNwpGpPermitTypes } from '@api/services/lookup/prefetch';

export interface HandleEditClickMethods {
  fetchNpr: (params: FetchNprParams) => void | Promise<unknown>;
  fetchNonPcn: (params: FetchNonPcnParams) => void | Promise<unknown>;
}

export interface HandleRequestAction {
  district: string;
  methods: HandleEditClickMethods;
  projectId: number;
  requestId: number;
  requestStatus: string;
  requestType: RequestTypeType;
  version: number;

  downloadPdf?: boolean;
  archived?: boolean;
}

export const handleEditRequestAction = ({
  district,
  downloadPdf = false,
  methods,
  projectId,
  requestId,
  requestStatus,
  requestType,
  version,
  archived,
}: HandleRequestAction): void => {
  const arTableId = `aquatic-resources-table-${requestId}`;
  const store = getAppStore();
  const { fetchNpr, fetchNonPcn } = methods;

  store.doResetReduxFormData();
  useRequest.getState().resetRequest();
  useTableInput.getState().resetTableInput(arTableId);

  switch (requestType) {
    case RequestType.PreApplication:
      store.doFetchPreApp(projectId, requestId, requestStatus, downloadPdf, archived);
      break;
    case RequestType.ViolationComplaint:
      store.doFetchViolationComplaint(projectId, requestId, requestStatus, downloadPdf, archived);
      break;
    case RequestType.JurisdictionalDetermination:
      store.doFetchJD(projectId, requestId, '2', requestType, requestStatus, downloadPdf, archived);
      break;
    case RequestType.DelineationReport:
    case RequestType.AquaticResourceDelineationReport:
    case RequestType.DelineationReportAndJurisdictionalDetermination:
    case RequestType.AquaticResourceDelineationReportAndJurisdictionalDetermination:
      store.doFetchJD(projectId, requestId, '1', requestType, requestStatus, downloadPdf, archived);
      break;
    case RequestType.NationwidePermit:
    case RequestType.PreconstructionNotification:
      store.doFetchPermit(projectId, requestId, '4', requestType, requestStatus, downloadPdf, archived);
      store.doFetchGPPermitsByDistrict(district);
      prefetchCreditUnitsByDistrict(district);
      break;
    case RequestType.IndividualPermit:
    case RequestType.ApplicationForDAPermit:
      store.doFetchPermit(projectId, requestId, '3', requestType, requestStatus, downloadPdf, archived);
      store.doFetchGPPermitsByDistrict(district);
      prefetchCreditUnitsByDistrict(district);
      break;
    case RequestType.NoPermitRequired:
    case RequestType.ActivityBasedNoPermitRequired:
      fetchNpr({
        isGenerate: downloadPdf,
        projectID: projectId,
        requestID: requestId,
        requestStatus,
        version,
        archived,
      });
      break;
    case RequestType.NonPreconstructionNotification:
      prefetchNwpGpPermitTypes();
      fetchNonPcn({
        isGenerate: downloadPdf,
        projectId,
        requestId,
        requestStatus,
        version,
        archived,
      });
      break;
    case RequestType.PermitApplication:
      store.doFetchPermit(projectId, requestId, '12', requestType, requestStatus, downloadPdf, archived);
      store.doFetchGPPermitsByDistrict(district);
      prefetchCreditUnitsByDistrict(district);
      break;
    default:
      alert('NO FETCH API IS AVAILABLE FOR THIS REQUEST TYPE!');
      break;
  }
};
